import { gql } from "@apollo/client";

// TODO, decide if we can consolidate these mutations
export const updateAgent = gql`
    mutation ($updateUserData: UpdateUserInput!) {
        updateAgent(updateUserData: $updateUserData) {
            name
            status
            twilioStatusChangedAt
            email
            twilioSid
            skills {
                name
            }
        }
    }
`;

export const updateAgentPanel = gql`
    mutation ($updateUserData: UpdateUserInput!) {
        updateAgent(updateUserData: $updateUserData) {
            id
            name
            status
            twilioStatusChangedAt
            email
            twilioSid
            skills {
                name
            }
            teams {
                id
                name
            }
            channelCapacity {
                call
                customTask
                email
                sms
                voicemail
            }
            twilioAttributes
            agentActivityBreakdown {
                activityName
                duration
            }
        }
    }
`;

export const deleteUser = gql`
    mutation ($deleteUserData: DeleteUserInput!) {
        deleteUser(deleteUserData: $deleteUserData) {
            id
            name
            email
        }
    }
`;
